import React from "react";
import InputField from "../../components/InputField";
import Button from "../../components/Button";

const ExchangeRateEditModal = ({
  show,
  currency,
  value,
  onChange,
  onClose,
  onSave,
}) => {
  if (!show) return null;

  return (
    <>
      <div
        className="modal fade show"
        style={{
          display: "block",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                Edit Exchange Rate
              </h5>

              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              />
            </div>

            <div className="modal-body">
              <div className="mb-3">
                {/* <label className="form-label">
                  Currency
                </label> */}

                {/* <InputField
                  value={currency || ""}
                  readOnly
                /> */}
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Exchange Rate
                </label>

                <InputField
                  type="number"
                  value={value || ""}
                  onChange={(e) =>
                    onChange(e.target.value)
                  }
                  placeholder="Enter Exchange Rate"
                   onWheel={(e) => e.currentTarget.blur()}
                />
              </div>

              <div className="text-muted">
                1 {currency} = {value || 0} INR
              </div>
            </div>

            <div className="modal-footer">
              <Button
                className="btn btn-secondary"
                onClick={onClose}
                text="Cancel"
              />

              <Button
                className="btn btn-primary"
                onClick={onSave}
                text="Save"
              />
            </div>

          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ExchangeRateEditModal;
